import {FAILURE, PENDING, SUCCESS, RESET} from '../../constants'
import {getEntityObjects as getEntityObjectsAPI} from '../../../services/entities/entities_v2'

export async function getEntityObjects(dispatch, entityID, params) {
  dispatch({type: PENDING})
  try {
    const response = await getEntityObjectsAPI(entityID, params)
    dispatch({type: SUCCESS, payload: response})
  } catch (e) {
    console.log(`Get Entity Object Failed: ${e}`)
    dispatch({type: FAILURE, payload: e})
  }
}
